export default "__VITE_ASSET__34388eff__"